import React, { useState } from 'react'

import {
  Action,
  BarcodeField,
  FieldSpec,
  ImageField,
  LinkedField,
  PaginatedTable,
  ValueField,
} from 'src/components/Table'
import { Product } from 'src/api/models'
import { ProductLabel } from 'src/components/PrintLabel'
import { BulkPrint } from 'src/components/Print/Bulk'
import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  name: { id: 'name', label: 'Name', renderer: LinkedField(ValueField) },
  primaryBarcode: { id: 'primaryBarcode', label: 'Primary Barcode', ordering: 'primary_barcode__barcode', renderer: BarcodeField },
  primaryImage: { id: 'primaryImage', label: 'Primary Image', renderer: ImageField },
}

export const ProductListTable = (props: ListTableProps) => {
  const { paginator, fields, bulkActions, exportConfig } = props
  const [selected, setSelected] = useState<Product[]>([])
  const { print, renderPrintComponent } = useAsyncPrint()

  const bulkOptions: { [key: string]: Action } = {
    printProduct: {
      label: 'Print Products',
      action: () => {
        print((props) => (
          <BulkPrint
            {...props}
            items={selected}
            render={({ obj, onReadyToPrint }) => {
              onReadyToPrint?.()
              return <ProductLabel obj={obj} />
            }}
          />
        ))
      },
    },
  }

  return (
    <>
      {renderPrintComponent()}
      <PaginatedTable
        title="Products"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        onSelectedItem={setSelected}
        bulkActions={bulkActions?.map((action) => bulkOptions[action])}
        exportConfig={exportConfig}
      />
    </>
  )
}
